import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BdAppContainerService {
  public title$: Subject<string> = new Subject<string>();

  public title = '';

  public setTitle(title: string) {
    this.title = title;

    this.title$.next(title);
  }
}
